import styles from './Logs.module.css';

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactJson from 'react-json-view'
import { PageHeader, Timeline, DatePicker, Tag, Card, Spin, Empty, Button, Tabs, List, Typography, Modal } from 'antd';
import ReactMarkdown from 'react-markdown';
import moment from 'moment';

import {
  ReloadOutlined
} from '@ant-design/icons';

import {
  getLogs
} from 'store/ducks/logs.js';

const isJsonString = (str) => {
  if (typeof str !== 'string') return false;

  str = str.trim();

  if (typeof str === 'string' && (str[0] === '"' || str[str.length] === '"')) {
    return false;
  }

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};


const colors = {
  formDelete: 'gray',
  formCreate: 'green',
  userCreate: 'green',
  userDelete: 'red'
};

const Logs = () => {
  const dispatch = useDispatch();

  const logs = useSelector(state => state.logs.logs);
  const loading = useSelector(state => state.logs.getLogs.loading);

  const [day, setDay] = useState(moment());
  const [showMailDetailsModal, setShowMailDetailsModal] = useState(false);
  const [selectedMail, setSelectedMail] = useState({});

  const reload = () => dispatch(getLogs({
    day: day.format('x')
  }));

  useEffect(() => {
    dispatch(getLogs({
      day: day.format('x')
    }));
  }, [day]);

  return (
    <>
      <PageHeader
        title="Logs"
        style={{ border: '1px solid #f0f0f0', background: '#fff', margin: '0 0 15px 0' }}
        extra={[
          <DatePicker
            onChange={(date) => setDay(date)}
            allowClear={false}
            inputReadOnly={true}
            value={day}
            disabledDate={(current) => {
              return current && current > moment();
            }}
          />,
          <Button onClick={() => reload()}><ReloadOutlined /></Button>
        ]}
      />

      <Modal title={selectedMail.text}
        visible={showMailDetailsModal}
        footer={null}
        width={1000}
        onCancel={() => {
          setSelectedMail({});
          setShowMailDetailsModal(false);
        }} >
        <ReactJson
          src={selectedMail && isJsonString(selectedMail.value) ? JSON.parse(selectedMail.value) : {}}
          indentWidth={2}
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false} />
      </Modal>

      <Spin spinning={loading} size="large">
        <Card style={{ width: '100%', minHeight: 224, padding: '0' }}>
          <Tabs animated={false}>
            <Tabs.TabPane tab="Mail" key="mail">
              <List bordered
                dataSource={logs ? logs.filter((log) => log.type === 'emailSent' || log.type === 'emailError').reverse() : []}
                renderItem={(log) => (
                  <List.Item>
                    <List.Item.Meta title={<>
                      {log.type === 'emailSent' && <Tag color="green">Success</Tag>}
                      {log.type === 'emailError' && <Tag color="red">Error</Tag>}
                      {log.text.indexOf('noreply.questionscout.com') === -1 && <Tag color="purple">SMTP</Tag>}
                      {log.text}
                    </>} description={moment(log.createdAt).format('DD.MM.YYYY HH:mm')} />
                    <div>
                      <Button type="primary" onClick={() => {
                        setSelectedMail(log);
                        setShowMailDetailsModal(true);
                      }}>Show Details</Button>
                    </div>
                  </List.Item>
                )} />
              {logs && logs.filter((log) => log.type === 'emailSent').length === 0 && !loading && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
            </Tabs.TabPane>

            <Tabs.TabPane tab="Timeline" key="timeline">
              <Timeline mode="left" style={{ padding: '40px 0 0 0' }}>
                {logs && logs.length > 0 && logs.filter((log) => log.type !== 'emailSent' && log.type !== 'emailError').map((log) =>
                  <Timeline.Item color={colors[log.type]} label={moment(log.createdAt).format('DD.MM.YYYY HH:mm')}>
                    <ReactMarkdown source={log.text} className={styles.markdown} />
                    {log.tags.filter((tag) => tag.text).map((tag) => <Tag style={{ display: 'inline-block' }} color={tag.color}>{tag.text}</Tag>)}
                  </Timeline.Item>
                )}

                {logs && logs.filter((log) => log.type !== 'emailSent').length === 0 && !loading && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              </Timeline>
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </Spin>
    </>
  );
}

export default Logs;
